import React from "react";
import {useSelector} from "react-redux";
import DashboardInfoCard from "./dashboardInfoCard";
import {getTotalDueAndSavingForCurrentMonth} from "../../Util/dataHelper";
import {PARTNER_TYPE_AFFILIATE} from "../PartnerPortal/leftNavbar";

const getValuesForAffiliate = (partnerAccounts, billingData, partnerInfo) => {
    const totalAccounts = partnerAccounts?.getTotalCountOfActiveAccounts() ?? 0;
    const paidAccounts = partnerAccounts?.getTotalCountOfPaidAccounts() ?? 0;
    const unpaidAccounts = totalAccounts - paidAccounts;

    const {
        discountedAmount
    } = getTotalDueAndSavingForCurrentMonth(billingData?.billingFormattedObj ?? {}, partnerInfo?.billingDiscountAmount ?? 0);

    const result = [
        {label: "Total Accounts", value: totalAccounts},
        {label: "Paid Accounts", value: paidAccounts},
        {label: "Unpaid Accounts", value: unpaidAccounts},
        {label: "Earned This Month", value: "$" + discountedAmount}
    ]

    return result;
}

const getValuesForPremiumOrReseller = (partnerAccounts, billingData, partnerInfo) => {
    const totalAccounts = partnerAccounts?.getTotalCountOfActiveAccounts() ?? 0;
    const paidAccounts = partnerAccounts?.getTotalCountOfPaidAccounts() ?? 0;
    const unpaidAccounts = totalAccounts - paidAccounts;

    const {
        afterDiscountAmount,
        discountedAmount
    } = getTotalDueAndSavingForCurrentMonth(billingData?.billingFormattedObj ?? {}, partnerInfo?.billingDiscountAmount ?? 0);

    const result = [
        {label: "Total Accounts", value: totalAccounts},
        {label: "Paid Accounts", value: paidAccounts},
        {label: "Unpaid Accounts", value: unpaidAccounts},
        {label: "Current Month Due", value: "$" + afterDiscountAmount},
        {label: "Discount This Month", value: "$" + discountedAmount}
    ]

    return result;
}

const DashboardSummeryInfoSection = ({partnerInfo}) => {
    const billingDataObj = useSelector(state => state.partnerBillingData);
    const partnerAccountsObj = useSelector(state => state.partnerAccounts);
    if (partnerInfo === null) {
        return <></>
    }

    const pairs = (partnerInfo.partnerType === PARTNER_TYPE_AFFILIATE) ? 
        getValuesForAffiliate(partnerAccountsObj, billingDataObj, partnerInfo) : 
        getValuesForPremiumOrReseller(partnerAccountsObj, billingDataObj, partnerInfo);

    const getInfoCards = () => {
        return pairs.map(({label, value}, ind) => {
            let goToDetails = false;
            if (ind > 1) goToDetails = true;
            return (
                <div key={ind} className="align-self-center justify-content-center w-100">
                    <DashboardInfoCard details={label} number={value} goToDetails={goToDetails}
                                       partnerType={partnerInfo.partnerType}/>
                </div>
            )
        })
    }

    return (
        <div className="d-flex card-container">
            {getInfoCards()}
        </div>
    )
}

export default DashboardSummeryInfoSection;
